import * as React from "react";
import type { GitRefQueryParamsProps } from "../BranchSelector/useProjectGitRef";
import { RunbookRunNowLayout } from "./RunbookRunNowLayout";
type RunbookRunNowPageProps = GitRefQueryParamsProps;
export function RunbookRunNowPage({ queryParams, setQueryParams }: RunbookRunNowPageProps) {
    return <RunbookRunNowLayout goal={{}} queryParams={queryParams} setQueryParams={setQueryParams}/>;
}
